import { FormattedMessage } from 'react-intl';

import { LineupActionCta } from '../LineupActionCta';

type Props = {
  onTrack?: () => void;
  url: string;
};

export const ComposeCta = ({ onTrack, url }: Props) => {
  return (
    <LineupActionCta color="primary" to={url} onClick={onTrack}>
      <FormattedMessage
        id="LobbyLineupActions.Register"
        defaultMessage="Register"
      />
    </LineupActionCta>
  );
};
